import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { DecimalPercentInput } from '@ui/components/form/DecimalPercentInput';
import { get, useFormContext } from 'react-hook-form';

export function TargetContributionMarginForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext();
  const targetContributionMarginFieldPath = fieldPath(
    'targetContributionMargin',
  );
  const targetContributionMarginFieldError = get(
    form.formState.errors,
    targetContributionMarginFieldPath,
  );

  const targetContributionMarginFormHandlers = form.register(
    targetContributionMarginFieldPath,
  );

  return (
    <>
      <FormControl isInvalid={!!targetContributionMarginFieldError} isRequired>
        <FormLabel htmlFor={targetContributionMarginFieldPath}>
          Target Contribution Margin:
        </FormLabel>

        <DecimalPercentInput
          {...targetContributionMarginFormHandlers}
          id={targetContributionMarginFieldPath}
        />

        <ErrorMessage
          name={targetContributionMarginFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />

        <FormHelperText>
          As a decimal percentage (e.g. 0.3 for 30%)
        </FormHelperText>
      </FormControl>
    </>
  );
}
